<template>
    <ul>
        <slot />
    </ul>
</template>
